var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.346558 9.87109C0.346558 7.66195 2.13742 5.87109 4.34656 5.87109H27.561C29.7701 5.87109 31.561 7.66195 31.561 9.87109V11.6812L0.346578 11.6812L0.346578 13.6812L12.8651 13.6812C13.0732 15.0433 14.2497 16.0867 15.67 16.0867C17.0903 16.0867 18.2669 15.0433 18.475 13.6812L31.561 13.6812V22.3024C31.561 24.5115 29.7701 26.3024 27.561 26.3024H4.34656C2.13742 26.3024 0.346558 24.5115 0.346558 22.3024V9.87109Z",
    fill: "#CE838E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1298 7.0061C11.1298 4.96298 12.1681 2.46582 15.675 2.46582C19.182 2.46582 20.2103 5.18999 20.2103 7.0061",
    stroke: "#CE838E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTimeIcon);
export default __webpack_public_path__ + "static/media/FullTimeIcon.50acfaa338a753e5001a523dabb47259.svg";
export { ForwardRef as ReactComponent };